import { Box, IconButton, useTheme, Avatar } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import logo from "../../assests/CircularFondoAzul.png";
import logo2 from "../../assests/CircularFullColor.png";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      backgroundColor={colors.CatoAccent[500]}
      height="80px"      // Define una altura fija
      maxHeight="100px"  // Opcional: Limita la altura máxima si es dinámico
    >
      <Box display="flex" borderRadius="3px">
        <Box display="flex" alignItems="center">         
          <Avatar
            variant="square"
            src={theme.palette.mode === "light" ? logo : logo2}
            alt="Logo"
            sx={{
              backgroundColor: "transparent",
              verticalAlign: "middle",
              width: { xs: "80px", sm: "90px", md: "90px" },
              height: "auto",
            }}
          />
        </Box>
      </Box>
      <Box display="flex">
        <IconButton sx={{ color: colors.softWhiteAccent[400] }} onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
       
      </Box>
    </Box>
  );
};


export default Topbar;
